import { useEffect, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Line, Pie } from "react-chartjs-2";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import FileBase64 from "react-file-base64";
import imageToBase64 from "image-to-base64/browser";
import _ from "lodash";
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Box,
  Button,
  Grid,
  Typography,
  withWidth,
  makeStyles,
  Paper,
  IconButton,
  Avatar,
} from "@material-ui/core";
import {
  FilterBar,
  Container,
  DataGrid,
  Paginate,
  InputText,
  Loading,
  SimpleDashCard,
  CompDashCard,
  PieChart,
} from "src/components";
import {
  ArrowBack as VoltarIcon,
  Equalizer as DashBoardIcon,
  SupervisedUserCircle as ClientesIcon,
  AutoAwesomeMotion as ModulosIcon,
  Bookmarks as CategoriaIcon,
  BusinessCenter as EditarIcon,
  MonetizationOn as CashbackIcon,
  CardGiftcard as PresentesIcon,
  WatchLater as CashbackVenctoIcon,
  AccountBalanceWallet as PossuiCashbackIcon,
  ArrowRight as ArrowRightIcon,
  ArrowDropDown as ArrowDropDownIcon,
  ArrowUpward as UpIcon,
  Map as MapIcon,
  ArrowDownward as DownIcon,
} from "@material-ui/icons";

import NumberFormat from "react-number-format";

import { useNavigate } from "react-router-dom";

import {
  carregarResumoTotalizadores,
  carregarGraficoTransacoes,
  carregarDadosComparativos,
} from "src/store/actions/fidelidade_dashboard";

function FidelidadeDashboard(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loading, totalizadores, grafico_transacoes, comparativos } =
    useSelector((state) => state.fidelidade_dashboard);

  async function loadData() {
    dispatch([
      carregarResumoTotalizadores(),
      carregarGraficoTransacoes(),
      carregarDadosComparativos(),
    ]);
  }

  useEffect(() => loadData(), []);

  function GraficoCashback({ dados } = props) {
    const data = {
      labels: dados.data,
      datasets: [
        {
          label: "R$ Enviados",
          data: dados.valor_enviados,
          fill: false,
          backgroundColor: "rgb(255, 99, 132)",
          borderColor: "rgba(255, 99, 132, 0.2)",
          yAxisID: "y-axis-1",
        },
        {
          label: "Qtde Enviados",
          data: dados.qtde_recebidos,
          fill: false,
          backgroundColor: "rgb(155, 99, 132)",
          borderColor: "rgba(155, 99, 132, 0.2)",
          yAxisID: "y-axis-2",
        },
        {
          label: "R$ Recebidos",
          data: dados.valor_recebidos,
          fill: false,
          backgroundColor: "rgb(55, 99, 132)",
          borderColor: "rgba(55, 99, 132, 0.2)",
          yAxisID: "y-axis-1",
        },
        {
          label: "Qtde Recebidos",
          data: dados.qtde_enviados,
          fill: false,
          backgroundColor: "rgb(5, 20, 132)",
          borderColor: "rgba(5, 20, 132, 0.2)",
          yAxisID: "y-axis-2",
        },
      ],
    };

    const options = {
      scales: {
        yAxes: [
          {
            type: "linear",
            display: true,
            position: "left",
            id: "y-axis-1",
          },
          {
            type: "linear",
            display: true,
            position: "right",
            id: "y-axis-2",
            gridLines: {
              drawOnArea: false,
            },
          },
        ],
      },
    };

    return (
      <Card {...props}>
        <CardHeader title="Gráfico diário de CashBack (Ultimos 30 dias.)" />
        <Divider />
        <CardContent>
          <Box style={{ height: 400 }}>
            <Line data={data} options={options} height={120} />
          </Box>
        </CardContent>
      </Card>
    );
  }

  function GraficoTotalCashBack({ dados } = props) {
    const data = {
      labels: ["Enviados", "Recebidos"],
      datasets: [
        {
          label: "Valores",
          data: [
            _.sum(dados.valor_enviados).toFixed(2),
            _.sum(dados.valor_recebidos).toFixed(2),
          ],
          backgroundColor: [
            "rgba(255, 99, 132, 0.2)",
            "rgba(55, 99, 132, 0.2)",
          ],
          borderColor: ["rgb(255, 99, 132)", "rgb(55, 99, 132)"],
          borderWidth: 2,
          hoverOffset: 4,
        },
        {
          label: "Quantidades",
          data: [
            parseInt(_.sum(dados.qtde_enviados)),
            parseInt(_.sum(dados.qtde_recebidos)),
          ],
          backgroundColor: ["rgba(155, 99, 132, 0.2)", "rgba(5, 20, 132, 0.2)"],
          borderColor: ["rgb(155, 99, 132)", "rgb(5, 20, 132)"],
          borderWidth: 1,
          hoverOffset: 4,
        },
      ],
    };
    return (
      <Card {...props}>
        <CardHeader title="Totalizador de Cashback (Ultimos 30 dias.)" />
        <Divider />
        <CardContent>
          <Box style={{ height: 400, paddingTop: 50 }}>
            <Pie data={data} />
          </Box>
        </CardContent>
      </Card>
    );
  }

  return (
    <Container
      title="Dashboard fidelidade"
      buttonsRight={[
        {
          title: "Dashboard",
          icon: <DashBoardIcon />,
          onClick: () => navigate("/app/dashboard/"),
          disabled: true,
        },
        {
          title: "Mapa",
          icon: <MapIcon />,
          onClick: () => navigate("/app/dashboard/mapa"),
        },
        {
          title: "Resumo",
          icon: <ClientesIcon />,
          onClick: () => navigate("/app/dashboard/resumo"),
          // disabled: false,
        },
      ]}
    >
      <Loading loading={loading} />
      <Grid container spacing={2}>
        <Grid item lg={3} sm={6} xl={3} xs={12} style={{ height: 130 }}>
          <SimpleDashCard
            title="Total de clientes"
            titleValue={totalizadores.total_clientes}
            icon={<ClientesIcon />}
            iconColor={"#EE3060"}
            subTitleValue={totalizadores.total_clientes_cashback}
            subTitle="Possuem Cashback"
            subIcon={<PossuiCashbackIcon />}
          />
        </Grid>
        <Grid item lg={3} sm={6} xl={3} xs={12} style={{ height: 130 }}>
          <SimpleDashCard
            title="Total de cashback"
            titleValue={
              <NumberFormat
                decimalScale={2}
                fixedDecimalScale={true}
                defaultValue={0}
                prefix={"R$ "}
                thousandSeparator={"."}
                decimalSeparator={","}
                displayType={"text"}
                value={totalizadores.total_cashback}
              />
            }
            icon={<CashbackIcon />}
            iconColor={"#EE3060"}
            subTitleValue={
              <NumberFormat
                decimalScale={2}
                fixedDecimalScale={true}
                defaultValue={0}
                prefix={"R$ "}
                thousandSeparator={"."}
                decimalSeparator={","}
                displayType={"text"}
                value={parseFloat(totalizadores.ticket_medio)}
              />
            }
            subTitle="Possuem Cashback"
          />
        </Grid>
        <Grid item lg={3} sm={6} xl={3} xs={12} style={{ height: 130 }}>
          <SimpleDashCard
            title="Total de presentes"
            titleValue={
              <NumberFormat
                decimalScale={2}
                fixedDecimalScale={true}
                defaultValue={0}
                prefix={"R$ "}
                thousandSeparator={"."}
                decimalSeparator={","}
                displayType={"text"}
                value={parseFloat(totalizadores.total_presentes)}
              />
            }
            icon={<PresentesIcon />}
            iconColor={"#EE3060"}
            subTitleValue={totalizadores.total_clientes_presentes}
            subTitle="Possuem Cashback"
          />
        </Grid>
        <Grid item lg={3} sm={6} xl={3} xs={12} style={{ height: 130 }}>
          <SimpleDashCard
            title="Cashback vencendo"
            titleValue={
              <NumberFormat
                decimalScale={2}
                fixedDecimalScale={true}
                defaultValue={0}
                prefix={"R$ "}
                thousandSeparator={"."}
                decimalSeparator={","}
                displayType={"text"}
                value={parseFloat(totalizadores.total_cashback_vencendo)}
              />
            }
            icon={<CashbackVenctoIcon />}
            iconColor={"#EE3060"}
            subTitleValue={totalizadores.qtde_cashback_vencendo}
            subTitle="Cashbacks vencendo..."
          />
        </Grid>
        <Grid item lg={8} sm={12} xl={8} xs={12}>
          <GraficoCashback dados={grafico_transacoes} />
        </Grid>
        <Grid item lg={4} sm={12} xl={4} xs={12}>
          <GraficoTotalCashBack dados={grafico_transacoes} />
        </Grid>
        <Grid item lg={3} sm={6} xl={3} xs={12}>
          <CompDashCard
            title="R$ CashBack Recebidos"
            valorAnterior={
              <NumberFormat
                decimalScale={2}
                fixedDecimalScale={true}
                defaultValue={0}
                prefix={"R$ "}
                thousandSeparator={"."}
                decimalSeparator={","}
                displayType={"text"}
                value={parseFloat(comparativos.cashback_in_old)}
              />
            }
            valorAtual={
              <NumberFormat
                decimalScale={2}
                fixedDecimalScale={true}
                defaultValue={0}
                prefix={"R$ "}
                thousandSeparator={"."}
                decimalSeparator={","}
                displayType={"text"}
                value={parseFloat(comparativos.cashback_in_now)}
              />
            }
            upValue={
              comparativos.cashback_in_now > comparativos.cashback_in_old
            }
          />
        </Grid>
        <Grid item lg={3} sm={6} xl={3} xs={12}>
          <CompDashCard
            title="R$ CashBack Enviados"
            valorAnterior={
              <NumberFormat
                decimalScale={2}
                fixedDecimalScale={true}
                defaultValue={0}
                prefix={"R$ "}
                thousandSeparator={"."}
                decimalSeparator={","}
                displayType={"text"}
                value={parseFloat(comparativos.cashback_out_old)}
              />
            }
            valorAtual={
              <NumberFormat
                decimalScale={2}
                fixedDecimalScale={true}
                defaultValue={0}
                prefix={"R$ "}
                thousandSeparator={"."}
                decimalSeparator={","}
                displayType={"text"}
                value={parseFloat(comparativos.cashback_out_now)}
              />
            }
            upValue={
              comparativos.cashback_out_now > comparativos.cashback_out_old
            }
          />
        </Grid>
        <Grid item lg={3} sm={6} xl={3} xs={12}>
          <CompDashCard
            title="R$ CashBack Expirado/Expirando"
            valorAnterior={
              <NumberFormat
                decimalScale={2}
                fixedDecimalScale={true}
                defaultValue={0}
                prefix={"R$ "}
                thousandSeparator={"."}
                decimalSeparator={","}
                displayType={"text"}
                value={parseFloat(comparativos.cashback_expired_old)}
              />
            }
            valorAtual={
              <NumberFormat
                decimalScale={2}
                fixedDecimalScale={true}
                defaultValue={0}
                prefix={"R$ "}
                thousandSeparator={"."}
                decimalSeparator={","}
                displayType={"text"}
                value={parseFloat(comparativos.cashback_expired_now)}
              />
            }
            upValue={
              comparativos.cashback_expired_now >
              comparativos.cashback_expired_old
            }
          />
        </Grid>
        <Grid item lg={3} sm={6} xl={3} xs={12}>
          <CompDashCard
            title="Número de Clientes"
            valorAnterior={comparativos.clientes_count_old}
            valorAtual={comparativos.clientes_count_now}
            upValue={
              comparativos.clientes_count_now > comparativos.clientes_count_old
            }
          />
        </Grid>
      </Grid>
    </Container>
  );
}

export default withWidth()(FidelidadeDashboard);
